import { Col, Row } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { ICart } from 'interface/cart.interface';
import moment from 'moment';

interface IProps {
  cart?: ICart;
}
export default function InfoCart(props: IProps): JSX.Element {
  const { cart } = props;
  return (
    <Content>
      <Row
        justify="end"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <div className="text-sm font-medium text-neutral-70">
            <div>Người tạo</div>
          </div>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-medium">
            {cart?.user_created.fullName}
          </span>
        </Col>

        <Col span={3} className="">
          <span className="text-sm font-medium text-neutral-70">
            <div>Email </div>
          </span>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-medium">
            {cart?.user_created.email}
          </span>
        </Col>
      </Row>
      <Row
        justify="end"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <div className="text-sm font-medium text-neutral-70">
            <div>Khối phát hành</div>
          </div>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-medium">
            {cart?.user_created.division}
          </span>
        </Col>

        <Col span={3} className="">
          <span className="text-sm font-medium text-neutral-70">
            <div>Công ty phát hành </div>
          </span>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-medium">
            {cart?.user_created.organization}
          </span>
        </Col>
      </Row>
      <Row
        justify="end"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <div className="text-sm font-medium text-neutral-70">
            <div>Đơn vị phát hành</div>
          </div>
        </Col>
        <Col span={21} className="">
          <span className="text-sm font-medium">
            {cart?.user_created.departmentName}
          </span>
        </Col>
      </Row>
      <Row
        justify="end"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <div className="text-sm font-medium text-neutral-70">
            <div>Đặt hàng theo Ni</div>
          </div>
        </Col>
        <Col span={21} className="">
          {/* chưa biết */}
          <span className="text-sm font-medium">- </span>
        </Col>
      </Row>
      <Row
        justify="end"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <div className="text-sm font-medium text-neutral-70">
            <div>Cập nhật lần cuối</div>
          </div>
        </Col>
        <Col span={21} className="">
          <span className="text-sm font-medium">
            {/* chưa biết */}
            {moment(cart?.user_created?.updatedAt).format('DD/MM/YYYY')}
          </span>
        </Col>
      </Row>
      <Row
        justify="end"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="mb-1 mt-4"
      >
        <Col span={24} className="">
          <div className="text-sm font-medium text-neutral-70">
            <div>Mô tả</div>
          </div>
        </Col>
        <Col span={24} className="">
          <span className="text-sm font-medium">{cart?.description}</span>
        </Col>
      </Row>
    </Content>
  );
}
